import { useState, useEffect } from 'react';
import apiClient from '../apiClient';

const useStatusOptions = () => {
  const [statusOptions, setStatusOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatusOptions = async () => {
      try {
        const response = await apiClient.get('/api/status');
        if (response.data && Array.isArray(response.data)) {
          setStatusOptions(response.data.map(item => item.status));
        }
      } catch (err) {
        setError(err);
        console.error('Failed to fetch status options:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStatusOptions();
  }, []);

  return { statusOptions, loading, error };
};

export default useStatusOptions;
